import BGImage from "../../assets/img/banner.jpg";
import { getInscriptionPeriod } from "../../utils/date";

function Banner() {
  const inscription = getInscriptionPeriod();
  let title = "IUTA Excelencia Académica"
  if (inscription.regular) {
    title = "Alumnos nuevos, regulares, y reincorporaciones";
  } else if (inscription.admision) {
    title = "Alumnos nuevos y reincorporaciones"
  }

  return (
    <div className="image-cover half_banner" style={{background: `url(${BGImage}) no-repeat`, minHeight: "500px"}}>
      <div className="container bg-transparent">
        <div className="row">
          <div className="col-xl-6 col-lg-7 col-md-12 col-sm-12">
            <div className="card rounded-4 bg-light">
              <div className="hero-caption py-3 px-0 text-center">
                <h3 className="m-0 pb-2">{title}</h3>
                {!inscription.endedInscriptions && (
                  <h3 className="text-center text-warning pb-2">
                    Inscripciones abiertas para el período {inscription.label}
                  </h3>
                )}
                <h5 className="text-muted">
                  ¡Graduate como Técnico Superior Universitario en solo 28 meses!
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;